export const COMMENT_FILE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
export const COMMENT_FILE_ACCEPT = COMMENT_FILE_EXTENSIONS.map(extension => `.${extension}`).join(',');
export const COMMENT_MAX_FILES = 5;
export const COMMENT_MAX_FILE_SIZE = 20 * 1024 * 1024;
export const COMMENT_MAX_TOTAL_SIZE = 100 * 1024 * 1024;

export const validateCommentFiles = (newFiles: File[], existingCount = 0): string | null => {
    if (existingCount + newFiles.length > COMMENT_MAX_FILES) {
        return 'К комментарию можно прикрепить не более 5 файлов.';
    }
    for (const file of newFiles) {
        const extension = file.name.split('.').pop()?.toLowerCase() || '';
        if (!file.name.includes('.') || !COMMENT_FILE_EXTENSIONS.includes(extension)) {
            return `Файл «${file.name}»: недопустимый формат. Разрешены JPG, JPEG, PNG, WEBP, GIF, DOC, DOCX, XLS, XLSX, PPT, PPTX.`;
        }
        if (file.size > COMMENT_MAX_FILE_SIZE) {
            return `Файл «${file.name}» превышает 20 МБ.`;
        }
    }

    const totalSize = newFiles.reduce((total, file) => total + file.size, 0)
        + existingCount * COMMENT_MAX_FILE_SIZE;
    if (totalSize > COMMENT_MAX_TOTAL_SIZE) {
        return 'Общий размер файлов не должен превышать 100 МБ.';
    }
    return null;
};
